// Keep the applicant form and loan routing aligned when customer search resets
// the wizard. CustomerTypeStep is no longer mounted at this point.
export function returningCustomerJourney(customerType?: string) {
  return customerType === 'CORPORATE'
    ? { customerType: 'company' as const, loanType: 'BUSINESS' as const }
    : { customerType: 'individual' as const, loanType: 'PERSONAL' as const };
}
